
export { usePartnerWebAppInitializer } from "/home/runner/work/capsicum/capsicum/libs/features/partner-page/web/src/hooks/usePartnerWebAppInitializer.ts"